import { useEffect, useState } from '../../common/common';
import { useErrorContext } from '../../context/ErrorContext';
import axiosJWT from '../../secureAPI/axiosJWT';
import useGetUserData from '../../secureAPI/GetUserData';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { showToast } from '../../Utils/toastUtils';
import { validateSerachSupplierForm } from '../../validation/Authentication/Validation';
import Navigations from '../../common/useNavigation';

const MidAddSuppliers = (type) => {
    const { users } = useGetUserData();
    const { navigateDashboard } = Navigations();
    const [isLoading, setisLoading] = useState(false);
    const { setValidationError, clearAllErrors } = useErrorContext();
    const [suppliers, setSuppliers] = useState([]);
    const [reqestedSupllier, setRequestedSuplier] = useState([]);
    const [isrequested, setisRequested] = useState(false);
    const [isconnected, setisConnected] = useState(false);
    useEffect(() => {
        const logUserData = () => {
            if (users?.length > 0) {
                const userTypes = users[0]['UserType'];
                const usertypeArray = typeof userTypes === 'string' ?
                    userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];

                const hasOne = usertypeArray.includes(1);
                // const hasTwo = usertypeArray.includes(2);

                if (type === 'buyer' && users[0]['IsPersonalDetils'] === 1 && (hasOne)) {
                    // Seller logic
                } else {
                    navigateDashboard('buyer');
                }
            }
        };

        if (Array.isArray(users) && users.length > 0) {
            logUserData();
        }
    }, [users, type, navigateDashboard]);
    // useEffect(() => {
    //     if (Array.isArray(users) && users.length > 0) {
    //         console.log('useEffect called, users:', users);
    //         logUserData();
    //     }
    // }, [users]);
    // const logUserData = () => {
    //     if (users?.length > 0) {
    //         console.log('log user data');
    //     }
    // };
    const [values, setValue] = useState({
        searchSupplier: "",
    });
    // Reusable function to handle validation and set errors
    const validateAndSetErrors = (values) => {
        const validationErrors = validateSerachSupplierForm(values);
        Object.keys(validationErrors).forEach(field => setValidationError(field, validationErrors[field]));
        return validationErrors;
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setValue(prevValues => ({ ...prevValues, [name]: value }));
        if (Object.keys(validateAndSetErrors(values)).length === 0) clearAllErrors();
    };
    const handleSubmit = e => {
        e.preventDefault();
        const validationErrors = validateAndSetErrors(values);
        if (Object.keys(validationErrors).length === 0) {
            clearAllErrors();
            SearchSupplier(); // Assuming checkLogin() is a function to handle actual login logic
        }
    };


    // const SearchSupplier = async () => {
    //     StartLoading(setisLoading);
    //     const { searchSupplier } = values;
    //     if (searchSupplier !== '' && searchSupplier.length === 10) {
    //         try {
    //             await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetSupplierRequest`, { data: { searchSupplier, app: 0 } }, { withCredentials: true })
    //                 .then((response) => {
    //                     StopLoading(setisLoading);
    //                     var result;
    //                     console.log(response)
    //                     if (response.data.requested === 0) {


    //                         showToast(response.data.message, 'error');


    //                         setSuppliers(response.data.data);


    //                     }
    //                     else if (response.data.requested === 1 && response.data.connected === 0) {
    //                         result = JSON.parse(JSON.stringify(response.data.data));

    //                         console.log({ data: response.data.data });


    //                         setSuppliers(response.data.data);
    //                         // setisConnected(true);
    //                         setisRequested(true);
    //                     }
    //                     else {
    //                         console.log({ data: response.data.data });


    //                         result = JSON.parse(JSON.stringify(response.data.data));
    //                         setSuppliers(response.data.data);
    //                     }
    //                 })
    //                 .catch((err) => {
    //                     console.log(err);
    //                     console.log({ data: err.data.data });

    //                     StopLoading(setisLoading);
    //                     showToast('something went wrong ! please try again', 'error');
    //                 });
    //         } catch (err) {

    //             console.log(err);

    //             StopLoading(setisLoading);
    //             showToast(err.message, 'error');
    //         }
    //     }
    //     else {
    //         StopLoading(setisLoading);
    //         showToast("Please enter a valid Supplier Code. Try again later. ", 'error');
    //     }
    // }
    const SearchSupplier = async () => {
        StartLoading(setisLoading);
        setRequestedSuplier([]);
        const { searchSupplier } = values;

        if (searchSupplier && searchSupplier.length === 10) {
            try {
                const response = await axiosJWT.post(
                    `${process.env.REACT_APP_API_URL}/api/GetSupplierRequest`,
                    { data: { searchSupplier, app: 0 } },
                    { withCredentials: true }
                );

                const { data } = response;

                if (data.requested === 0 && data.connected === 0) {
                    showToast(data.message, 'error');
                    // console.log(data)
                    setSuppliers(data.data);
                    setRequestedSuplier([]);
                }
                else if (data.requested === 1 && data.connected === 0) {
                    // console.log(data)
                    setSuppliers(data.requestedData);
                    setisRequested(true);
                    setRequestedSuplier([]);
                } else {
                    setSuppliers(data.data);
                    setRequestedSuplier([]);
                }

                // console.log('Supplier Response:', data);
            } catch (err) {
                setRequestedSuplier(err?.response?.data?.requestedData);
                // // ✅ Get custom message from API error response
                // const customMessage = err?.response?.data?.message || 'Something went wrong! Please try again.';
                // showToast(customMessage, 'error');
            } finally {
                StopLoading(setisLoading);
            }
        } else {
            StopLoading(setisLoading);
            showToast("Please enter a valid 10-digit Supplier Code.", 'error');
        }
    };

    const handleselect = async (unique_key) => {
        StartLoading(setisLoading);
        const { searchSupplier } = values;
        if (searchSupplier !== '') {
            try {
                const res = await axiosJWT.post(
                    `${process.env.REACT_APP_API_URL}/api/sendRequesttoSupplier`,
                    { data: { searchSupplier, app: 0 } },
                    { withCredentials: true }
                );

                StopLoading(setisLoading);
                var result = JSON.parse(JSON.stringify(res.data));

                if (result.success === 1) {
                    if (result.sent === 1) {
                        // ✅ Update only that supplier in state
                        setSuppliers(prev =>
                            prev.map(s =>
                                s.unique_key === unique_key
                                    ? { ...s, isRequested: true }
                                    : s
                            )
                        );
                    } else if (result.sent === 0) {
                        showToast(result.message, 'error');
                    }
                } else if (result.success === 0) {
                    showToast(result.message, 'error');
                }
            } catch (err) {
                StopLoading(setisLoading);
                showToast("Failed to find supplier, please try again later", 'error');
            }
        }
    };

    
    return { users, isLoading, values, handleChange, handleSubmit, suppliers, isrequested, isconnected, handleselect, reqestedSupllier }
}

export default MidAddSuppliers